import Model from '../Model'

export default class PrivateImage extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/private-image'
    }
}
